// extracted by mini-css-extract-plugin
module.exports = {"frame":"raindow-frame_frame__0YEZj","animatedgradient":"raindow-frame_animatedgradient__8BHl2","content":"raindow-frame_content__BVVd7"};